import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const onSubmitStyles = async (collectionId, techpackIdProductDesignIdMapList) => {
	try {
		let body = {
			collectionId: collectionId,
			techpackIdProductDesignIdMapList: techpackIdProductDesignIdMapList
		};
		const { data } = await ApiClient.POST('addFromInspiration', body);
		toastSuccess(data.message);
		return data;
	} catch ({ response }) {
		if (response && response.data && response.data.message) {
			toastError(response.data.message);
		} else {
			toastError('Request was unsuccessful.');
		}
	}
};

const onUploadSingleDesign = async (designList, prevResponse) => {
	try {
		const modifiedList = designList?.map((item) => {
			let { docUrl: base64Str, ...rest } = item;
			item = { base64Str, ...rest };
			return item;
		});

		let body = {
			documentDTOList: modifiedList
		};
		if (prevResponse) {
			body['response'] = prevResponse;
		}
		const { data } = await ApiClient.POST('uploadSingleStyle', { ...body });
		return data;
	} catch ({ response }) {
		if (response && response.data && response.data.message) {
			toastError(response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
		return 'FAILURE';
	}
};

const onUploadInMultiSyle = async (design) => {
	try {
		let { docUrl: base64Str, ...rest } = design;
		design = { base64Str, ...rest };
		const { data } = await ApiClient.POST('addDesigns', design);
		return data;
	} catch ({ response }) {
		if (response && response.data && response.data.message) {
			toastError(response.data.message);
		} else {
			toastError('Request was unsuccessful.');
		}
		return 'FAILURE';
	}
};

// const getAllTnaProductList = async (orderId) => {
// 	try {
// 		const { data } = await Http.GET('getInitialAllOrder', '/' + orderId);
// 		return data;
// 	} catch ({ response }) {
// 		if (response && response.data && response.data.message) {
// 			toastError(response.data.message);
// 		} else {
// 			toastError('Something went wrong! Please try again.');
// 		}
// 	}
// };

// const onDleteTask = async (id) => {
// 	try {
// 		const { data } = await Http.DELETE('subTaskAction', {}, id);
// 		return data;
// 	} catch ({ response }) {
// 		if (response && response.data && response.data.message) {
// 			toastError(response.data.message);
// 		} else {
// 			toastError('Something went wrong! Please try again.');
// 		}
// 	}
// };
// const onApproveTask = async (taskId) => {
// 	try {
// 		const { data } = await Http.POST('approveTask', {}, taskId);
// 		return data;
// 	} catch ({ response }) {
// 		if (response && response.data && response.data.message) {
// 			toastError(response.data.message);
// 		} else {
// 			toastError('Something went wrong! Please try again.');
// 		}
// 	}
// };

export default {
	// getAllTnaProductList,
	// onDleteTask,
	// onApproveTask,
	onUploadSingleDesign,
	onUploadInMultiSyle,
	onSubmitStyles
};
